import { useEffect } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


const Terms = () => {
  // I18N
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.terms');
  }, []);

  // <div className="spinnerContainer">
  //     <Spinner animation="border" role="status" className="spinner">
  //         <span className="visually-hidden">Loading...</span>
  //     </Spinner>   
  // </div>
  return (
    <>
      <iframe
        src="https://schedulum.org/terms.html"
        // src="http://192.168.98.234:3000/terms.html"
        // src="http://localhost:3000/terms.html"
        style={{ width: '100%', height: '100vh', border: 'none' }}
        title="Simple Page"
      />
    </>
  )
};
  
export default Terms;